var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1389,
    height: 440,
    viewBox: "0 0 1389 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1131.93 226.13C1140.2 223.604 1136.16 210.384 1127.89 212.909C1119.08 215.603 1123.12 228.824 1131.93 226.13Z",
    fill: "url(#paint0_linear_bubbles)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.13 14.4901C1245.39 11.9643 1241.35 -1.25627 1233.09 1.26946C1224.82 3.79519 1228.86 17.0158 1237.13 14.4901Z",
    fill: "url(#paint1_linear_bubbles)",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M540.091 390.753C550.559 387.553 545.508 371.028 535.04 374.227C524.572 377.426 529.623 393.952 540.091 390.753Z",
    fill: "url(#paint2_linear_bubbles)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M318.107 370.057C328.575 366.858 323.524 350.332 313.056 353.532C302.038 356.899 307.088 373.425 318.107 370.057Z",
    fill: "url(#paint3_linear_bubbles)",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M508.64 337.122C513.047 335.775 511.027 329.165 506.619 330.512C502.212 331.859 504.232 338.469 508.64 337.122Z",
    fill: "url(#paint4_linear_bubbles)",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M685.861 398.602C690.268 397.255 688.248 390.645 683.84 391.992C679.433 393.339 681.453 399.949 685.861 398.602Z",
    fill: "url(#paint5_linear_bubbles)",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M836.31 264.08C840.717 262.733 838.697 256.123 834.289 257.47C829.882 258.817 831.902 265.427 836.31 264.08Z",
    fill: "url(#paint6_linear_bubbles)",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.47 154.513C1019.88 153.166 1017.86 146.556 1013.45 147.903C1009.04 149.25 1011.06 155.86 1015.47 154.513Z",
    fill: "url(#paint7_linear_bubbles)",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M912.573 405.204C916.98 403.856 914.96 397.246 910.553 398.593C906.145 399.94 908.165 406.551 912.573 405.204Z",
    fill: "url(#paint8_linear_bubbles)",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.95 261.779C1177.36 260.432 1175.34 253.822 1170.93 255.169C1166.52 256.516 1168.54 263.126 1172.95 261.779Z",
    fill: "url(#paint9_linear_bubbles)",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.77 297.86C1337.18 296.513 1335.16 289.902 1330.75 291.25C1326.89 292.428 1328.91 299.038 1332.77 297.86Z",
    fill: "url(#paint10_linear_bubbles)",
    fillOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.76 392.992C1345.17 391.645 1343.15 385.035 1338.74 386.382C1334.33 387.729 1336.35 394.339 1340.76 392.992Z",
    fill: "url(#paint11_linear_bubbles)",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.67 134.474C1245.07 133.127 1243.05 126.516 1238.65 127.863C1234.24 129.21 1236.26 135.821 1240.67 134.474Z",
    fill: "url(#paint12_linear_bubbles)",
    fillOpacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.05 73.1722C1256.46 71.8251 1254.44 65.2148 1250.03 66.5619C1246.17 67.7406 1248.19 74.3508 1252.05 73.1722Z",
    fill: "url(#paint13_linear_bubbles)",
    fillOpacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.59 173.2C1277.99 171.853 1275.97 165.242 1271.56 166.589C1267.16 167.937 1269.18 174.547 1273.59 173.2Z",
    fill: "url(#paint14_linear_bubbles)",
    fillOpacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.82 56.5741C1212.23 55.227 1210.21 48.6168 1205.8 49.9638C1201.39 51.3109 1203.41 57.9212 1207.82 56.5741Z",
    fill: "url(#paint15_linear_bubbles)",
    fillOpacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.24 82.0358C1079.65 80.6887 1077.63 74.0784 1073.22 75.4255C1069.37 76.6041 1071.39 83.2144 1075.24 82.0358Z",
    fill: "url(#paint16_linear_bubbles)",
    fillOpacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M618.417 428.25C622.825 426.903 620.804 420.292 616.397 421.639C612.54 422.818 614.561 429.428 618.417 428.25Z",
    fill: "url(#paint17_linear_bubbles)",
    fillOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M705.358 413.122C715.826 409.923 710.775 393.397 700.307 396.596C689.289 399.964 694.339 416.489 705.358 413.122Z",
    fill: "url(#paint18_linear_bubbles)",
    fillOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M778.354 293.237C788.822 290.038 783.771 273.512 773.304 276.711C762.285 280.079 767.336 296.605 778.354 293.237Z",
    fill: "url(#paint19_linear_bubbles)",
    fillOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1382.85 400.608C1393.31 397.409 1388.26 380.883 1377.8 384.082C1366.78 387.45 1371.83 403.976 1382.85 400.608Z",
    fill: "url(#paint20_linear_bubbles)",
    fillOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.01 207.384C1288.48 204.185 1283.43 187.659 1272.96 190.859C1262.49 194.058 1267.54 210.584 1278.01 207.384Z",
    fill: "url(#paint21_linear_bubbles)",
    fillOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1271.03 115.557C1281.5 112.358 1276.44 95.832 1265.98 99.0312C1255.51 102.231 1260.56 118.756 1271.03 115.557Z",
    fill: "url(#paint22_linear_bubbles)",
    fillOpacity: 0.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.71 367.272C1045.18 364.073 1040.13 347.547 1029.66 350.746C1019.19 353.945 1024.24 370.471 1034.71 367.272Z",
    fill: "url(#paint23_linear_bubbles)",
    fillOpacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M890.604 94.2513C901.072 91.0521 896.021 74.5263 885.553 77.7256C875.085 80.9249 880.136 97.4506 890.604 94.2513Z",
    fill: "url(#paint24_linear_bubbles)",
    fillOpacity: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M576.424 438.675C584.688 436.149 580.647 422.929 572.383 425.454C563.568 428.148 567.609 441.369 576.424 438.675Z",
    fill: "url(#paint25_linear_bubbles)",
    fillOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.13 351.678C1336.4 349.152 1332.36 335.932 1324.09 338.457C1315.83 340.983 1319.87 354.204 1328.13 351.678Z",
    fill: "url(#paint26_linear_bubbles)",
    fillOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.01 388.895C1173.47 385.696 1168.42 369.17 1157.95 372.369C1147.49 375.569 1152.54 392.094 1163.01 388.895Z",
    fill: "url(#paint27_linear_bubbles)",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.74 289.889C1040.2 286.69 1035.15 270.164 1024.69 273.364C1013.67 276.731 1018.72 293.257 1029.74 289.889Z",
    fill: "url(#paint28_linear_bubbles)",
    fillOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M361.125 311.736C371.592 308.537 366.542 292.011 356.074 295.211C345.055 298.578 350.106 315.104 361.125 311.736Z",
    fill: "url(#paint29_linear_bubbles)",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M826.09 380.439C834.354 377.913 830.313 364.692 822.049 367.218C813.234 369.912 817.275 383.133 826.09 380.439Z",
    fill: "url(#paint30_linear_bubbles)",
    fillOpacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M916.09 316.191C924.354 313.665 920.314 300.444 912.049 302.97C903.235 305.664 907.275 318.885 916.09 316.191Z",
    fill: "url(#paint31_linear_bubbles)",
    fillOpacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M970.033 214.778C978.297 212.252 974.257 199.031 965.993 201.557C957.729 204.083 961.769 217.303 970.033 214.778Z",
    fill: "url(#paint32_linear_bubbles)",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.78 133.304C1166.04 130.779 1162 117.558 1153.74 120.084C1145.47 122.609 1149.52 135.83 1157.78 133.304Z",
    fill: "url(#paint33_linear_bubbles)",
    fillOpacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.25 300.022C1296.51 297.497 1292.47 284.276 1284.21 286.802C1275.39 289.496 1279.44 302.716 1288.25 300.022Z",
    fill: "url(#paint34_linear_bubbles)",
    fillOpacity: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.95 217.276C1368.21 214.75 1364.17 201.53 1355.91 204.055C1347.64 206.581 1351.68 219.802 1359.95 217.276Z",
    fill: "url(#paint35_linear_bubbles)",
    fillOpacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.32 342.431C1236.59 339.905 1232.54 326.685 1224.28 329.21C1215.47 331.904 1219.51 345.125 1228.32 342.431Z",
    fill: "url(#paint36_linear_bubbles)",
    fillOpacity: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.09 19.2869C1320.35 16.7611 1316.31 3.54054 1308.04 6.06627C1299.23 8.76041 1303.27 21.981 1312.09 19.2869Z",
    fill: "url(#paint37_linear_bubbles)",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76587 435.385C18.0299 432.859 13.9893 419.638 5.72524 422.164C-3.08973 424.858 0.9509 438.079 9.76587 435.385Z",
    fill: "url(#paint38_linear_bubbles)",
    fillOpacity: 0.3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M111.918 373.446C120.182 370.92 116.141 357.7 107.877 360.225C99.613 362.751 103.654 375.972 111.918 373.446Z",
    fill: "url(#paint39_linear_bubbles)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_bubbles",
    x1: 1008.05,
    y1: -29.7588,
    x2: 826.5,
    y2: 482.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31F16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762431,
    stopColor: "#F31F16",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F31F16",
    stopOpacity: 0.12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.f19676b3.svg";
export { ForwardRef as ReactComponent };